import { motion } from "framer-motion";

const CHAPTERS = [
  {
    num: "01",
    title: "Mission",
    body: "To provide investors with better access to market information, opportunities, and insights related to unlisted and Pre-IPO shares while promoting responsible and informed investment decisions.",
  },
  {
    num: "02",
    title: "Vision",
    body: "To become a trusted platform for investors seeking knowledge, transparency, and opportunities in the growing Pre-IPO and unlisted securities market.",
  },
  {
    num: "03",
    title: "Commitment",
    body: "We believe informed investors make better decisions. We are committed to clear information and professional support — while encouraging every investor to evaluate each opportunity against their own financial goals and risk tolerance.",
  },
];

export const Manifesto = () => {
  return (
    <section id="mission" className="relative border-t border-slate-200 bg-[#FAF9FF] py-24 lg:py-32">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-16 px-6 lg:grid-cols-12 lg:px-10">
        <div className="lg:col-span-4">
          <div className="lg:sticky lg:top-28">
            <p className="font-mono2 text-[11px] uppercase tracking-[0.35em] text-[#6D28D9]/90">The Manifesto</p>
            <h2 className="font-display mt-4 text-3xl font-semibold tracking-tight text-slate-900 sm:text-4xl lg:text-5xl">
              Why we <span className="gold-text">exist</span>
            </h2>
            <motion.div
              initial={{ opacity: 0, scale: 0.96 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.9 }}
              className="relative mt-12 hidden overflow-hidden border border-slate-200 lg:block"
              style={{ clipPath: "polygon(0 0, 100% 0, 100% 88%, 88% 100%, 0 100%)" }}
            >
              <div className="absolute inset-0 z-10 bg-gradient-to-t from-[#FFFFFF] via-transparent to-transparent" />
              <div className="absolute -left-10 -top-10 z-10 h-40 w-40 rounded-full bg-[#6D28D9]/20 blur-3xl" />
              <img
                src="https://images.unsplash.com/photo-1512403754473-27835f7b9984?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwyfHxmaW5hbmNpYWwlMjBza3lzY3JhcGVyJTIwbHV4dXJ5JTIwb2ZmaWNlJTIwc3RvY2slMjBtYXJrZXQlMjB0cmFkaW5nfGVufDB8fHx8MTc4ODI5MDQzNHww&ixlib=rb-4.1.0&q=85"
                alt="Financial district"
                className="h-80 w-full object-cover opacity-80"
              />
              <p className="absolute bottom-4 left-4 z-20 font-mono2 text-[10px] uppercase tracking-[0.25em] text-[#6D28D9]">
                Private Markets Desk · Mumbai
              </p>
            </motion.div>
          </div>
        </div>

        <div className="lg:col-span-8">
          {CHAPTERS.map((c, i) => (
            <motion.div
              key={c.num}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.8, delay: 0.05 * i }}
              className="group grid grid-cols-[auto_1fr] gap-8 border-b border-slate-200 py-14 first:pt-0"
            >
              <span className="font-display text-6xl font-semibold text-slate-200 transition-colors duration-500 group-hover:text-[#6D28D9]/40 lg:text-8xl">
                {c.num}
              </span>
              <div className="pt-2 lg:pt-5">
                <h3 className="font-display text-2xl font-semibold tracking-tight text-slate-900 lg:text-3xl">{c.title}</h3>
                <p className="mt-4 max-w-2xl text-base leading-relaxed text-slate-500 lg:text-lg">{c.body}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
